import { useEffect, useState, useRef } from "react";
import { getItem, getItems, markRead as markReadAction, onChangeEvent } from "../actions/notificationsActions";
import { usePersistentState } from './usePersistentState'
import useApi from "./useApi";

export const useNotifications = (hotelId, roomOccupationId) => {
    const [loading, setLoading] = useState(false)
    const [items, setItems] = usePersistentState('notifications', null)
    const [itemLoading, setItemLoading] = useState(false)
    const [item, setItem] = usePersistentState('notification', null)
    const [error, setError] = useState(null)
    const onNotificationChangeSubscription = useRef(null)
    const { get } = useApi();

    useEffect(() => {
        if (!roomOccupationId) return
        if (!onNotificationChangeSubscription.current && roomOccupationId) {
            onNotificationChangeSubscription.current = onChangeEvent(roomOccupationId, r => {
                if (item?.id === r.id) {
                    loadItem(r.id);
                }
                loadItems()
            })
        }
    }, [])

    useEffect(() => {
        return () => {
            if (onNotificationChangeSubscription.current) {
                try {
                    if (onNotificationChangeSubscription.current?.unsuscribe) {
                        onNotificationChangeSubscription.current?.unsuscribe();
                    }
                } finally {
                    onNotificationChangeSubscription.current = null;
                }
            }
        }
    }, [])

    useEffect(() => {
        if (items === null && roomOccupationId) {
            setLoading(true)
            loadItems()
        }
    }, [])

    const loadItems = async () => {
        try {
            setLoading(true);
            const response = await get(`hotels/${hotelId}/stays/${roomOccupationId}/notifications`);
            if (response) {
                setItems(response);
            } else {
                console.error('Error on load items.');
            }
        } catch (error) {
            console.error('Error on load items:', error);
        } finally {
            setLoading(false);
        }
    };

    const loadItem = (id, force = false) => {
        return new Promise((resolve) => {
            setItemLoading(true);
            getItem(id).then(r => {
                setItemLoading(false);
                setItem(r);
                resolve(r);
            })
        })
    }

    const markRead = (id) => {
        return markReadAction(id).then(r => {
            if (item?.id === r.id) {
                setItem({ ...item, unread: r.unread })
            }
            if (items) {
                // TODO:: Mejorar esto
                const itemInCollection = items.map(i => {
                    if (i.id === r.id) {
                        i.unread = r.unread;
                    }
                    return i;
                })
                setItems(itemInCollection)
            }
        })
    }

    const clear = () => {
        setItems(null)
    }

    return {
        loading,
        items,
        item,
        itemLoading,
        loadItems,
        loadItem,
        markRead,
        error,
        clear
    }

}